export default "__VITE_ASSET__d54a54c5__"